<script>
export default {
  name: "TopBlockCard"
}
</script>

<template>
  <div class="topBlockCard">
      <div class="topBlockCard__header">
        <slot name="header">Заголовок</slot>
      </div>
      <div class="topBlockCard__content">
        <slot name="content">Контент</slot>
      </div>
      <div class="topBlockCard__buttons">
          <slot name="buttons">
            Кнопки
          </slot>
      </div>
      <slot name="default"></slot>
  </div>
</template>

<style lang="scss" scoped>
.topBlockCard {
  position: relative;
  text-align: left;
  background-color: var(--cd-card-bg);
  border-radius: var(--cd-card-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &__header {
    padding: 24px;
    font-size: 20px;
  }
  &__content {
    padding: 24px;
    font-size: 36px;
    color: var(--cd-highlight-text);
    font-weight: 500;
    font-family: var(--cd-bold-font);
  }
  &__buttons {
    padding: 24px;
    display: flex;
    justify-content: left;
    align-items: center;
    gap: 16px;
  }
}
</style>
